import React from 'react';
import { Prompt } from 'react-router';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Editor from './Editor';
import Preview from './Preview';
import swal from 'sweetalert';
import '../../../components/AlertStyles/Alert.css';

class Form extends React.Component {
  handleSaveAsDraft = () => {
    const { dirty, values } = this.props;

    if (!dirty) {
      // alert("Please make some changes before saving!");
      swal({
        text: 'Please make some changes before saving!',
        position: 'center center',
      });
    } else {
      values.isSaveToDraft = true;
      this.refs.eateryForm.dispatchEvent(new Event('submit'));
    }
  };

  handleEdit = () => {
    this.props.setFieldValue('isPreview', false);
    window.scrollTo(0, 0);
  };

  render() {
    const { errors, dirty, submitCount, values, handleSubmit, derived } = this.props;
    let isDraft = derived.eatery ? derived.eatery.draft : false;
    return (
      <div>
        <form ref="eateryForm" onSubmit={handleSubmit}>
          <Prompt
            when={dirty}
            message="Your changes will be lost. Are you sure you want to leave?"
          />
          {values.isPreview ? (
            <Preview {...this.props} />
          ) : (
              <Editor {...this.props} />
            )}

          <FormControl className="block" margin="normal">
            <Button
              className="mr-4"
              color="primary"
              type="submit"
              variant="contained"
            >
              {values.isPreview ? 'Submit' : 'Preview'}
            </Button>
            {values.isPreview ? (
              <Button
                color="primary"
                type="button"
                onClick={this.handleEdit}
                variant="outlined"
              >
                Edit
              </Button>
            ) : (
                <Button
                  color="primary"
                  type="button"
                  // onClick={this.handleSaveAsDraft}
                  onClick={(!isDraft && values.id) ? null : this.handleSaveAsDraft}
                  variant="outlined"
                  disabled={(!isDraft && values.id) ? true : false}
                >
                  Save as draft
              </Button>
              )}
          </FormControl>
          {submitCount > 0 && !!errors.form && (
            <FormHelperText error>{errors.form}</FormHelperText>
          )}
        </form>
      </div>
    );
  }
}

export default Form;
